import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Image from '../../ui/Image';
import Button from '../../ui/Button';
import { getFullAttachmentUrl } from '@services/api/index.js'

const ProductShowcase = ({ 
  products = [], 
  showMore = false, 
  layout = 'showcase' // 'showcase' | 'full'
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleMoreClick = () => {
    navigate('/copyright/products');
  };

  const handleProductClick = (product) => {
    navigate(`/copyright/products/${product.id}`);
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('zh-CN');
  };

  const getGridClass = () => {
    if (layout === 'full' || layout === 'grid') {
      return 'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4';
    }
    return 'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 gap-4';
  };

  return (
    <div className="product-showcase-section mb-8">
      <div className="flex justify-between items-center mb-4">
      {showMore && (
      <h2 className="text-xl font-bold text-gray-900">
          {t('copyright.products.title', '登记产品展示')}
        </h2>
      )}
        {showMore && (
          <Button
            variant="outline"
            size="sm"
            onClick={handleMoreClick}
            className="text-blue-600 border-blue-600 hover:bg-blue-50"
          >
            {t('common.more', '更多')}
          </Button>
        )}
      </div>

      <div className={`product-showcase ${getGridClass()}`}>
        {products.map((product) => (
          <div
            key={product.id}
            className="product-card bg-white rounded-lg overflow-hidden border border-gray-200
                       hover:shadow-md transition-shadow duration-200 cursor-pointer"
            onClick={() => handleProductClick(product)}
          >
            <div className="product-cover-container">
              <Image
                src={getFullAttachmentUrl(product?.coverId) }
                alt={product.title}
                className="product-cover w-full max-h-64 aspect-[3/4] bg-gray-100"
                imgClassName="w-full h-full object-cover"
                fallback="https://images.unsplash.com/photo-1544947950-fa07a98d237f?w=400&h=600&fit=crop&auto=format"
              />
            </div>
            
            <div className="product-info p-3">
              <div className="product-title font-medium text-gray-900 text-sm line-clamp-2 mb-1">
                {product.title}
              </div>
              
              {(layout === 'full' || layout === 'grid') && (
                <div className="product-meta text-xs text-gray-600 space-y-1">
                  {product.author && (
                    <div className="flex items-center">
                      <span>👤</span>
                      <span className="ml-1">{product.author}</span>
                    </div>
                  )}
                  {product.registrationDate && (
                    <div className="flex items-center">
                      <span>📅</span>
                      <span className="ml-1">{formatDate(product.registrationDate)}</span>
                    </div>
                  )}
                  <div className="mt-2">
                    <Button
                      variant="outline"
                      size="sm"
                      className="w-full text-blue-600 border-blue-600 hover:bg-blue-50"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleProductClick(product);
                      }}
                    >
                      {t('copyright.products.viewDetail', '查看详情')}
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>

      {products.length === 0 && (
        <div className="text-center py-8 text-gray-500">
          {t('copyright.products.noData', '暂无产品信息')}
        </div>
      )}
    </div>
  );
};

export default ProductShowcase; 